/**
 * 配置站点地图路由
 * @priority 0.7
 * @changefreq weekly
 */

//* Vue Router
import type { RouteRecordRaw } from "vue-router";

export default [
    //* 搜索页面
    {
        name: "Search",
        path: "/search",
        meta: { routeParent: "Home", name: "SearchResult", type: "Search" },
        component: () => import("@/views/search/main/index.vue"),
    },
    {
        name: "SearchGene",
        path: "/search/gene",
        meta: { routeParent: "Search", name: "Gene", type: "Search" },
        component: () => import("@/views/search/list/view/Gene.vue"),
    },
    {
        name: "SearchModel",
        path: "/search/model",
        meta: { routeParent: "Search", name: "Model", type: "Search" },
        component: () => import("@/views/search/list/view/Model.vue"),
    },
    {
        name: "SearchDisease",
        path: "/search/disease",
        meta: { routeParent: "Search", name: "Disease", type: "Search" },
        component: () => import("@/views/search/list/view/Disease.vue"),
    },
    {
        name: "SearchMutation",
        path: "/search/mutation",
        meta: { routeParent: "Search", name: "Variant", type: "Search" },
        component: () => import("@/views/search/list/view/Mutation.vue"),
    },
    {
        name: "SearchTool",
        path: "/search/tool",
        meta: { routeParent: "Search", name: "Tools", type: "Search" },
        component: () => import("@/views/search/list/view/Tool.vue"),
    },
    //* 工具页面
    {
        name: "Chatagent",
        path: "/chatagent",
        meta: { type: "AI-Agent" },
        component: () => import("@/views/chatagent/index.vue"),
    },
    {
        name: "Tool",
        path: "/tool",
        meta: { type: "Tools" },
        component: () => import("@/views/tool/views/main/index.vue"),
    },
    {
        path: "/tool/abbreviation-converter",
        name: "AbbreviationConverter",
        component: () => import("@/views/tool/views/abbreviation-converter/index.vue"),
    },
    {
        path: "/tool/genetic-comparison",
        name: "GeneticComparison",
        meta: { mode: "gene" },
        component: () => import("@/views/tool/views/comparison/index.vue"),
    },
    {
        path: "/tool/diseases-comparison",
        name: "DiseasesComparison",
        meta: { mode: "disease" },
        component: () => import("@/views/tool/views/comparison/index.vue"),
    },
    {
        path: "/tool/model-comparison",
        name: "ModelComparison",
        meta: { mode: "model" },
        component: () => import("@/views/tool/views/comparison/index.vue"),
    },
    {
        path: "/tool/rna-splicer",
        name: "RnaSplicer",
        meta: { type: "RNA Splicer" },
        component: () => import("@/views/tool/views/rna-splicer/main/index.vue"),
    },
    {
        path: "/tool/rna-splicer/:id",
        name: "RnaSplicerResult",
        meta: { type: "RNA Splicer" },
        component: () => import("@/views/tool/views/rna-splicer/result/index.vue"),
    },
    {
        path: "/tool/rna-splicer/manual",
        name: "RnaSplicerManual",
        meta: { type: "RNA Splicer" },
        component: () => import("@/views/tool/views/rna-splicer/manual/index.vue"),
    },
    {
        path: "/tool/pathogenicity",
        name: "Pathogenicity",
        meta: { type: "Pathogenicity Predictor" },
        component: () => import("@/views/tool/views/pathogenicity/main/index.vue"),
    },
    {
        path: "/tool/pathogenicity/:id",
        name: "PathogenicityResult",
        meta: { type: "Pathogenicity Predictor" },
        component: () => import("@/views/tool/views/pathogenicity/result/index.vue"),
    },
    {
        path: "/tool/mouse-pheno-predict",
        name: "MousePhenoPredict",
        component: () => import("@/views/tool/views/mouse-pheno-predict/index.vue"),
    },
    {
        path: "/tool/mouse-pheno-predict/:id",
        name: "MousePhenoPredictResult",
        component: () => import("@/views/tool/views/mouse-pheno-predict/childrens/result/index.vue"),
    },
    {
        path: "/tool/sequence-alignment",
        name: "SequenceAlignment",
        component: () => import("@/views/tool/views/sequence-alignment/main/index.vue"),
    },
    {
        path: "/tool/sequence-alignment/result",
        name: "SequenceAlignmentResult",
        component: () => import("@/views/tool/views/sequence-alignment/result/index.vue"),
    },
    {
        path: "/tool/MTH",
        name: "MTH",
        component: () => import("@/views/tool/views/MTH/main/index.vue"),
    },
    {
        path: "/tool/MTH/:id",
        name: "MTHResult",
        component: () => import("@/views/tool/views/MTH/result/index.vue"),
    },
    {
        path: "/tool/signal-path",
        name: "SignalPath",
        component: () => import("@/views/tool/views/signal-path/index.vue"),
    },
    {
        path: "/tool/signal-path/result",
        name: "SignalPathResult",
        component: () => import("@/views/tool/views/signal-path/result/index.vue"),
    },
    {
        path: "/tool/signal-path/detail",
        name: "SignalPathDetail",
        component: () => import("@/views/tool/views/signal-path/detail/index.vue"),
    },
    {
        path: "/tool/DBSNP",
        name: "DBSNP",
        component: () => import("@/views/tool/views/dbsnp/index.vue"),
    },
    {
        path: "/tool/DBSNP/result",
        name: "DBSNPResult",
        component: () => import("@/views/tool/views/dbsnp/childrens/result/index.vue"),
    },
    {
        path: "/tool/cbl",
        name: "CBL",
        component: () => import("@/views/tool/views/cbl/index.vue"),
    },
    {
        path: "/tool/dg-prediction",
        name: "DGPrediction",
        component: () => import("@/views/tool/views/dg/index.vue"),
    },
    {
        path: "/tool/blat",
        name: "BLAT",
        component: () => import("@/views/tool/views/blat/main/index.vue"),
    },
    {
        path: "/tool/blat/:id",
        name: "BLATResult",
        component: () => import("@/views/tool/views/blat/result/index.vue"),
    },
    {
        path: "/tool/transform-id",
        name: "TransformID",
        component: () => import("@/views/tool/views/transform-id/index.vue"),
    },
    {
        path: "/tool/sequence-processor",
        name: "SequenceProcessor",
        component: () => import("@/views/tool/views/sequence-processor/main/index.vue"),
    },
    {
        path: "/tool/sequence-processor/:id",
        name: "SequenceProcessorResult",
        component: () => import("@/views/tool/views/sequence-processor/result/index.vue"),
    },
    {
        path: "/tool/aav_viability",
        name: "AAVViability",
        component: () => import("@/views/tool/views/aav-viability/main/index.vue"),
    },
    {
        path: "/tool/aav_viability/manual",
        name: "AAVViabilityManual",
        component: () => import("@/views/tool/views/aav-viability/manual/index.vue"),
    },
    {
        name: "ASOExperiment",
        path: "/tool/aso-exonpred",
        component: () => import("@/views/tool/views/aso/default/index.vue"),
    },

    {
        name: "ASOExperimentResult",
        path: "/tool/aso-exonpred/:id",
        component: () => import("@/views/tool/views/aso/result/index.vue"),
    },
] as RouteRecordRaw[];
